import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `
.legislation-tree-select-group-label {
  font-weight: 600;
}

.legislation-tree-select-group-count {
  color: ${dt('surface.300')};
  font-weight: 400;
}

.legislation-tree-select-node-text,
.legislation-tree-select-group-label {
  color: ${dt('surface.900')};
  white-space: normal;
  word-break: break-word;
}

.legislation-tree-select-node-text {
  display: block;
}
`;
